import React, { FC } from "react";
import { Heading } from "@digipost/dds-heading-react";
import { LoginCard } from "./LoginCard";
import BankId from "../../assets/bankid.svg?react";
import Buypass from "../../assets/buypass.svg?react";
import Translated from "../infrastructure/translation/Translated";
import { useEntrypointContext } from "../infrastructure/entrypoint/EntrypointContext";
import { Navigate } from "react-router";
import { useRootPath } from "../infrastructure/translation/useRootPath";

const Login: FC = (): React.ReactElement => {
  const rootPath = useRootPath();
  const entrypoint = useEntrypointContext();

  if (entrypoint.rolle === "VIRKSOMHET") {
    return <Navigate to={rootPath} />;
  }

  return (
    <main>
      <Heading level={1} size={"large"}>
        <Translated textKey={"login.header"} />
      </Heading>
      <p>
        <Translated textKey={"login.body"} />
      </p>
      <LoginCard
        title={"virksomhet.bankid_title"}
        description={"virksomhet.bankid_desc"}
        icon={<BankId />}
        loginMethod="nbid"
      />
      <LoginCard
        title={"virksomhet.buypass_title"}
        description={"virksomhet.buypass_desc"}
        icon={<Buypass />}
        loginMethod="buypass"
      />
    </main>
  );
};

export default Login;
